module.exports = __webpack_public_path__ + "media/views/about/images/box_star-7f98052a2018135e6f9f6d56cde1cfde.svg";